// import { Text, Line } from "@react-three/drei";
// import { calculateFontSize, createRectanglePoints } from "../utils";
// import SubArea from "./SubArea";
// import { useMemo } from "react";
// import * as THREE from "three";
// import { darkenColor } from "../../../utils/visualizerUtils";

// // Simple GradientMaterial for multiple tags
// export const GradientMaterial = ({ colors, transparent, opacity }) => {
//   const texture = useMemo(() => {
//     // Only create gradient for multiple colors
//     if (!colors || colors.length <= 1) return null;

//     try {
//       const canvas = document.createElement("canvas");
//       canvas.width = 64; // Small texture for performance
//       canvas.height = 64;
//       const context = canvas.getContext("2d");

//       // Create gradient
//       const gradient = context.createLinearGradient(0, 0, canvas.width, canvas.height);
//       const step = 1 / (colors.length - 1);

//       colors.forEach((color, index) => {
//         const colorStop = index * step;
//         if (isFinite(colorStop)) {
//           gradient.addColorStop(colorStop, color);
//         }
//       });

//       context.fillStyle = gradient;
//       context.fillRect(0, 0, canvas.width, canvas.height);

//       const texture = new THREE.CanvasTexture(canvas);
//       texture.needsUpdate = true;
//       return texture;
//     } catch (error) {
//       console.error("Error creating gradient texture:", error);
//       return null;
//     }
//   }, [colors]);

//   // Use gradient texture if available
//   if (texture) {
//     return <meshBasicMaterial map={texture} transparent={transparent} opacity={opacity || 1} side={THREE.DoubleSide} />;
//   }

//   // Fallback to single color
//   const fallbackColor = colors && colors.length > 0 ? colors[0] : "#0BDA51";
//   return <meshBasicMaterial color={fallbackColor} transparent={transparent} opacity={opacity || 1} side={THREE.DoubleSide} />;
// };

// function Area3D({ obj, opacity = 1, highlightColors }) {
//   const shouldUseGradient = highlightColors?.length > 1;

//   const baseColor = obj.color;
//   const sideColor = darkenColor(baseColor, 0.35);

//   const width = obj.size[0];
//   const length = obj.size[2];

//   const rotationY = (obj.rotation * Math.PI) / 180;

//   // ⬆ Increased base depth
//   const baseDepth = 0.1;
//   const sideHeight = 0.1;
//   const sideThickness = 0.01;

//   return (
//     <group rotation={[0, rotationY, 0]} receiveShadow castShadow>
//       {/* MAIN BASE */}
//       <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]} receiveShadow castShadow>
//         <boxGeometry args={[width, length, baseDepth]} />
//         {shouldUseGradient ? (
//           <GradientMaterial colors={highlightColors} transparent={opacity < 1} opacity={opacity} />
//         ) : (
//           <meshStandardMaterial color={baseColor} metalness={0.25} roughness={0.7} transparent={opacity < 1} opacity={opacity} />
//         )}
//       </mesh>

//       {/* SIDES */}
//       {/* Front */}
//       <mesh position={[0, sideHeight / 2, -length / 2]} castShadow receiveShadow>
//         <boxGeometry args={[width, sideHeight, sideThickness]} />
//         <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
//       </mesh>

//       {/* Back */}
//       <mesh position={[0, sideHeight / 2, length / 2]} castShadow receiveShadow>
//         <boxGeometry args={[width, sideHeight, sideThickness]} />
//         <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
//       </mesh>

//       {/* Left */}
//       <mesh position={[-width / 2, sideHeight / 2, 0]} castShadow receiveShadow>
//         <boxGeometry args={[sideThickness, sideHeight, length]} />
//         <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
//       </mesh>

//       {/* Right */}
//       <mesh position={[width / 2, sideHeight / 2, 0]} castShadow receiveShadow>
//         <boxGeometry args={[sideThickness, sideHeight, length]} />
//         <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
//       </mesh>

//       {/* TEXT LABEL */}
//       <Text
//         position={[0, baseDepth + 0.05, 0]}
//         // ⬇ Rotate with the area
//         rotation={[-Math.PI / 2, 0, 0]}
//         fontSize={Math.min(width, length) * 0.15}
//         color="black"
//         // ⬇ Fit text inside area width automatically
//         maxWidth={width * 0.8}
//         lineHeight={1}
//         anchorX="center"
//         anchorY="middle"
//       >
//         {obj.name}
//       </Text>
//     </group>
//   );
// }

// function AreaWrapper({ obj, areaLocationsToHighlight, opacity, isWareHouseInventoryRoute }) {
//   const rotationY = obj.rotation ? (-obj.rotation * Math.PI) / 180 : 0;
//   const points = createRectanglePoints(obj.size[0], obj.size[2]);

//   const { areaLocations, primaryColor } = areaLocationsToHighlight;

//   // Determine if this area should be highlighted
//   const isHighlighted = areaLocations?.includes(obj.code);

//   // Get colors for gradient if tags exist
//   const highlightColors = useMemo(() => {
//     if (isHighlighted && obj.tags && obj.tags.length > 0) {
//       return obj.tags.filter((tag) => tag.color !== null && tag.color !== undefined).map((tag) => tag.color);
//     }
//     return null;
//   }, [isHighlighted, obj.tags]);

//   // Determine if we should use gradient (multiple tags) or solid color
//   const shouldUseGradient = useMemo(() => {
//     return isHighlighted && obj.tags && obj.tags.length > 1;
//   }, [isHighlighted, obj.tags]);

//   // Determine the base color for this area
//   const areaColor = useMemo(() => {
//     if (isHighlighted) {
//       if (obj.tags && obj.tags.length > 0) {
//         return obj.tags[0].color || "#0BDA51"; // Base color (first tag)
//       }
//       return primaryColor || "#0BDA51";
//     }
//     return obj.color;
//   }, [isHighlighted, obj.tags, primaryColor, obj.color]);

//   // Calculate appropriate text size based on area dimensions
//   const textSize = useMemo(() => {
//     const minDimension = Math.min(obj.size[0], obj.size[2]);
//     return minDimension * 0.15;
//   }, [obj.size]);

//   if (!obj.subAreas?.length) {
//     return <Area3D obj={obj} highlightColors={[]} />;
//   }

//   const flatSubAreas = obj.subAreas.flatMap((row) => row);

//   return (
//     <group rotation={[0, rotationY, 0]}>
//       {flatSubAreas.map((subArea) => (
//         <SubArea
//           key={subArea.id}
//           isWareHouseInventoryRoute={isWareHouseInventoryRoute}
//           subArea={subArea}
//           obj={obj}
//           w={subArea.size[0]}
//           d={subArea.size[2]}
//           areaLocationsToHighlight={areaLocationsToHighlight}
//         />
//       ))}

//       {/* Area background */}
//       <mesh rotation={[-Math.PI / 2, 0, 0]}>
//         <planeGeometry args={[obj.size[0], obj.size[2]]} />

//         {/* Use GradientMaterial for multiple tags, solid color for single tag */}
//         {shouldUseGradient ? (
//           <GradientMaterial colors={highlightColors} transparent opacity={0.25} />
//         ) : (
//           <meshBasicMaterial color={areaColor} transparent opacity={0.25} side={THREE.DoubleSide} />
//         )}
//       </mesh>

//       {/* Border lines for the main area with proper rotation */}
//       <group rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.01, 0]}>
//         <Line points={points} color="black" lineWidth={1} />
//       </group>

//       {/* Main area text label */}
//       <Text
//         position={[0, 0.02, 0]}
//         fontSize={textSize}
//         color="black"
//         maxWidth={Math.min(obj.size[0], obj.size[2]) * 0.8}
//         lineHeight={1}
//         letterSpacing={0.02}
//         textAlign="center"
//         anchorX="center"
//         anchorY="middle"
//         rotation={[-Math.PI / 2, 0, 0]}
//         renderOrder={1}
//       >
//         {obj.name}
//       </Text>
//     </group>
//   );
// }

// export default AreaWrapper;

import { Text, Line } from "@react-three/drei";
import { createRectanglePoints } from "../utils";
import SubArea from "./SubArea";
import { useMemo } from "react";
import * as THREE from "three";
import { darkenColor } from "../../../utils/visualizerUtils";

// Simple GradientMaterial for multiple tags
export const GradientMaterial = ({ colors, transparent, opacity }) => {
  const texture = useMemo(() => {
    if (!colors || colors.length <= 1) return null;

    try {
      const canvas = document.createElement("canvas");
      canvas.width = 64;
      canvas.height = 64;
      const context = canvas.getContext("2d");

      const gradient = context.createLinearGradient(0, 0, canvas.width, canvas.height);
      const step = 1 / (colors.length - 1);

      colors.forEach((color, index) => {
        const colorStop = index * step;
        if (isFinite(colorStop)) {
          gradient.addColorStop(colorStop, color);
        }
      });

      context.fillStyle = gradient;
      context.fillRect(0, 0, canvas.width, canvas.height);

      const texture = new THREE.CanvasTexture(canvas);
      texture.needsUpdate = true;
      return texture;
    } catch (error) {
      console.error("Error creating gradient texture:", error);
      return null;
    }
  }, [colors]);

  if (texture) {
    return <meshBasicMaterial map={texture} transparent={transparent} opacity={opacity || 1} side={THREE.DoubleSide} />;
  }

  const fallbackColor = colors && colors.length > 0 ? colors[0] : "#0BDA51";
  return <meshBasicMaterial color={fallbackColor} transparent={transparent} opacity={opacity || 1} side={THREE.DoubleSide} />;
};

// Helper function to convert 2D coordinates to 3D positions relative to area
const convertSubAreaTo3D = (area, subArea, scaleFactor = 0.01) => {
  // Get area position in 3D
  const areaPosX = area.position?.[0] || 0;
  const areaPosZ = area.position?.[2] || 0;

  // Get area dimensions in 3D
  const areaWidth3D = area.size[0];
  const areaLength3D = area.size[2];

  // Parse subArea coordinates (they're strings in your example)
  const subX = parseFloat(subArea.x);
  const subY = parseFloat(subArea.y);
  const subWidth = parseFloat(subArea.width);
  const subHeight = parseFloat(subArea.height);

  // Convert from 2D canvas coordinates to 3D
  // Assuming origin is at top-left of area in 2D
  const relativeX = (subX - area.x1) * scaleFactor;
  const relativeY = (subY - area.y1) * scaleFactor;

  // Flip Y-axis (2D has Y down, 3D has Z up)
  const relativeZ = -relativeY;

  // Calculate center position relative to area center
  // Area center is at (0, 0, 0) in local coordinates
  const centerX = relativeX + (subWidth * scaleFactor) / 2 - areaWidth3D / 2;
  const centerZ = relativeZ - (subHeight * scaleFactor) / 2 + areaLength3D / 2;

  // Calculate size in 3D
  const width3D = subWidth * scaleFactor;
  const length3D = subHeight * scaleFactor;

  return {
    position: [centerX, 0.1, centerZ], // Keep Y at 0.1 for base height
    size: [width3D, 0, length3D],
    original2D: { subX, subY, subWidth, subHeight },
  };
};

function Area3D({ obj, opacity = 1, colors }) {
  const shouldUseGradient = colors?.length > 1;
  if (!colors) {
    // no color
    // colors = ["#ffffff"];
  }

  const width = obj.size[0];
  const length = obj.size[2];

  const rotationY = (obj.rotation * Math.PI) / 180;

  const baseDepth = 0.1;
  const sideHeight = 0.1;
  const sideThickness = 0.01;

  const sideColor = darkenColor(colors[0] || " ", 0.35);

  return (
    <group rotation={[0, rotationY, 0]}>
      {/* MAIN BASE */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]}>
        <boxGeometry args={[width, length, baseDepth]} />
        {shouldUseGradient ? (
          <GradientMaterial colors={colors} transparent={opacity < 1} opacity={opacity} />
        ) : (
          <meshStandardMaterial color={colors[0] || " "} metalness={0.25} roughness={0.7} transparent={opacity < 1} opacity={opacity} />
        )}
      </mesh>

      {/* SIDES */}
      {/* Front */}
      <mesh position={[0, sideHeight / 2, -length / 2]}>
        <boxGeometry args={[width, sideHeight, sideThickness]} />
        <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
      </mesh>

      {/* Back */}
      <mesh position={[0, sideHeight / 2, length / 2]}>
        <boxGeometry args={[width, sideHeight, sideThickness]} />
        <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
      </mesh>

      {/* Left */}
      <mesh position={[-width / 2, sideHeight / 2, 0]}>
        <boxGeometry args={[sideThickness, sideHeight, length]} />
        <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
      </mesh>

      {/* Right */}
      <mesh position={[width / 2, sideHeight / 2, 0]}>
        <boxGeometry args={[sideThickness, sideHeight, length]} />
        <meshStandardMaterial color={sideColor} metalness={0.3} roughness={0.8} />
      </mesh>

      {/* TEXT LABEL */}
      <Text
        position={[0, baseDepth + 0.05, 0]}
        rotation={[-Math.PI / 2, 0, 0]}
        fontSize={Math.min(width, length) * 0.15}
        color="black"
        maxWidth={width * 0.8}
        lineHeight={1}
        anchorX="center"
        anchorY="middle"
      >
        {obj.code}
      </Text>
    </group>
  );
}

function AreaWrapper({ obj, areaLocationsToHighlight, opacity, isWareHouseInventoryRoute, shouldRender = true }) {
  const rotationY = obj.rotation ? (-obj.rotation * Math.PI) / 180 : 0;
  const points = createRectanglePoints(obj.size[0], obj.size[2]);

  const { areaLocations, primaryColor } = areaLocationsToHighlight;

  const isHighlighted = areaLocations?.includes(obj.code);

  const hasTags = obj.tags?.length > 0;

  const highlightColors = useMemo(() => {
    if (!isHighlighted || !hasTags) return null;

    return obj.tags.filter((tag) => tag.color !== null && tag.color !== undefined).map((tag) => tag.color);
  }, [isHighlighted, hasTags, obj.tags]);

  const shouldUseGradient = useMemo(() => {
    return isHighlighted && hasTags && obj.tags.length > 1;
  }, [isHighlighted, hasTags, obj.tags]);

  const areaColor = useMemo(() => {
    if (!isHighlighted) return obj.color;

    if (hasTags) {
      return obj.tags[0].color ?? "#0BDA51";
    }

    return primaryColor ?? "#0BDA51";
  }, [isHighlighted, hasTags, obj.tags, primaryColor, obj.color]);

  const textSize = useMemo(() => {
    const minDimension = Math.min(obj.size[0], obj.size[2]);
    return minDimension * 0.15;
  }, [obj.size]);

  const shouldShowColor = shouldRender && isHighlighted;

  const colors = shouldShowColor ? (shouldUseGradient ? highlightColors : [areaColor]) : [areaColor];

  if (!obj.subAreas?.length) {
    return <Area3D obj={obj} colors={colors} />;
  }

  // Calculate scale factor (assuming width in 3D corresponds to some 2D measurement)
  const scaleFactor = obj.size[0] / Math.abs(obj.x2 - obj.x1);

  return (
    <group rotation={[0, rotationY, 0]}>
      {obj.subAreas.map((subArea) => {
        const subArea3D = convertSubAreaTo3D(obj, subArea, scaleFactor);
        return (
          <SubArea
            key={subArea.id}
            isWareHouseInventoryRoute={isWareHouseInventoryRoute}
            subArea={subArea}
            obj={obj}
            w={subArea3D.size[0]}
            d={subArea3D.size[2]}
            position={subArea3D.position}
            areaLocationsToHighlight={areaLocationsToHighlight}
          />
        );
      })}

      {/* Area background */}
      <mesh rotation={[-Math.PI / 2, 0, 0]}>
        <planeGeometry args={[obj.size[0], obj.size[2]]} />

        {shouldUseGradient ? (
          <GradientMaterial colors={highlightColors} transparent opacity={0.25} />
        ) : (
          <meshBasicMaterial color={areaColor} transparent opacity={0.25} side={THREE.DoubleSide} />
        )}
      </mesh>

      {/* Border lines for the main area with proper rotation */}
      <group rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.01, 0]}>
        <Line points={points} color="black" lineWidth={1} />
      </group>

      {/* Main area text label */}
      <Text
        position={[0, 0.02, 0]}
        fontSize={textSize}
        color="black"
        maxWidth={Math.min(obj.size[0], obj.size[2]) * 0.8}
        lineHeight={1}
        letterSpacing={0.02}
        textAlign="center"
        anchorX="center"
        anchorY="middle"
        rotation={[-Math.PI / 2, 0, 0]}
        renderOrder={1}
      >
        {obj.code}
      </Text>
    </group>
  );
}

export default AreaWrapper;
